import axiosInstance from './axiosInstance'

const BASE = '/user-tenants'

// Mensaje del backend: `message`, o el primero de una validación (validateFields: { errors: [{ msg }] }).
const getErrorMessage = (error, fallbackMessage) =>
  error.response?.data?.message || error.response?.data?.errors?.[0]?.msg || fallbackMessage

export const fetchAllAssignments = async () => {
  try {
    const response = await axiosInstance.get(BASE)
    return response.data
  } catch (error) {
    console.error('Error fetching all assignments:', error)
    return { assignments: [], summary: [], total: 0 }
  }
}

export const fetchAssignmentsByUser = async userId => {
  try {
    const response = await axiosInstance.get(`${BASE}/${userId}`)
    return {
      assignments: response.data.assignments || [],
      userRole: response.data.userRole ?? null,
    }
  } catch (error) {
    console.error('Error fetching user-tenant assignments:', error)
    return { assignments: [], userRole: null }
  }
}

export const assignTenantToUser = async (userId, tenantId, isPrimary = false, permissions = {}) => {
  try {
    const response = await axiosInstance.post(BASE, { userId, tenantId, isPrimary, ...permissions })
    return { success: true, ...response.data }
  } catch (error) {
    console.error('Error assigning tenant:', error)
    return {
      success: false,
      message: getErrorMessage(error, 'Error al asignar tenant'),
    }
  }
}

export const removeAssignment = async (userId, tenantId) => {
  try {
    const response = await axiosInstance.delete(`${BASE}/${userId}/${tenantId}`)
    return { success: true, ...response.data }
  } catch (error) {
    console.error('Error removing assignment:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al eliminar asignación',
    }
  }
}

export const setTenantPrimary = async (userId, tenantId) => {
  try {
    const response = await axiosInstance.put(`${BASE}/${userId}/primary/${tenantId}`)
    return { success: true, ...response.data }
  } catch (error) {
    console.error('Error setting primary tenant:', error)
    return {
      success: false,
      message: error.response?.data?.message || 'Error al establecer tenant principal',
    }
  }
}

export const updateAssignmentPermissions = async (userId, tenantId, { canRegister, canUpdate }) => {
  try {
    const response = await axiosInstance.patch(`${BASE}/${userId}/${tenantId}/permissions`, {
      canRegister,
      canUpdate,
    })
    return { success: true, ...response.data }
  } catch (error) {
    return {
      success: false,
      message: getErrorMessage(error, 'Error al actualizar los permisos'),
    }
  }
}
